import { render, staticRenderFns } from "./DrawerActivityTab.vue?vue&type=template&id=2be8e4eb&scoped=true"
import script from "./DrawerActivityTab.vue?vue&type=script&lang=js"
export * from "./DrawerActivityTab.vue?vue&type=script&lang=js"
import style0 from "./DrawerActivityTab.vue?vue&type=style&index=0&id=2be8e4eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be8e4eb",
  null
  
)

export default component.exports